import { gql, useQuery } from "@apollo/client";
import React from "react";
import { useRouteMatch } from "react-router";
import { Avatar, IndexTable, Layout, LegacyCard, Page, Text, Modal as Modals, Divider } from "@shopify/polaris";
import { Image } from "src/components/shopify/Image";
import { Link } from "react-router-dom";
import { Modal } from "src/hooks/modal";
import { UploadInternalTransferProof } from "./components/UploadInternalTransferProof";
import { PricesToolTips } from "../products/item/upload/PricesToolTips";
import { t } from "i18next";

const QUERY = gql`
  query supplierDisbursementDetail($uuid: String!) {
    supplierDisbursementDetail(uuid: $uuid) {
      orderId
      coid
      orderUUID
      item {
        id
        code
        price
        priceAfterDiscount
        thumbnail
        supplierCode
      }
      price
      color
      size
      commission
      deliveryFee
      handlingFee
      type
      amount
      description
    }
  }
`;

export function DisbursementDetailScreen() {
  const { params }: { params: { id: string } } = useRouteMatch();
  const { data, loading } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    variables: {
      uuid: params.id,
    },
  });

  const totalFee = data
    ? Number(
        (data.supplierDisbursementDetail as any[]).reduce(
          (a, b) => (a = a + Number(b.deliveryFee) + Number(b.handlingFee) + Number(b.commission)),
          0,
        ),
      )
    : 0;

  return (
    <Page title={`Disbursement Detail #${params.id}`}>
      <Layout>
        <Layout.Section>
          <LegacyCard>
            {/* <LegacyCard.Section>
              <UploadInternalTransferProof />
            </LegacyCard.Section> */}
            <LegacyCard.Section flush>
              <IndexTable
                headings={
                  [
                    { title: "" },
                    { title: "" },
                    {
                      title: (
                        <PricesToolTips messageId={2}>
                          {" "}
                          <span>
                            Sold Price (SOP)
                            <b> (?)</b>{" "}
                          </span>{" "}
                        </PricesToolTips>
                      ),
                    },
                    {
                      title: (
                        <div
                          onClick={() => {
                            Modal.dialog({
                              flush: true,
                              title: "VAT Explanation",
                              body: (
                                <>
                                  <Modals.Section>
                                    <strong>VALUE-ADDED TAX (VAT 10%)</strong>
                                  </Modals.Section>
                                  <Modals.Section>
                                    <p>
                                      This amount includes VAT (10%). Total fee is ${totalFee.toFixed(2)} ($
                                      {totalFee.toFixed(2)}/1.1) is the actual fee {Number(totalFee / 1.1).toFixed(2)}{" "}
                                      and ${(totalFee - totalFee / 1.1).toFixed(2)} is VAT that will be paid to General
                                      Department of Taxation on your behalf.
                                    </p>
                                  </Modals.Section>
                                  <Modals.Section>
                                    <p>
                                      តម្លៃនេះបានបូកបញ្ចូលពន្ធលើតម្លៃបន្ថែម (VAT) តម្លៃសរុប ${totalFee.toFixed(2)} ($
                                      {totalFee.toFixed(2)}/1.1) ថ្លៃសេវាពិតប្រាកដគឺត្រឹមតែ $
                                      {Number(totalFee / 1.1).toFixed(2)} ហើយ ${(totalFee - totalFee / 1.1).toFixed(2)}
                                      ជាពន្ធលើតម្លៃបន្ថែមដែលត្រូវបង់ទៅអគ្គនាយកដ្ឋានពន្ធដារ។
                                    </p>
                                  </Modals.Section>
                                  <Modals.Section>
                                    <p>Total: ${totalFee.toFixed(2)}</p>
                                    <p>
                                      Actual fee: total/1.1 = ${totalFee.toFixed(2)}
                                      /1.1 = ${Number(totalFee / 1.1).toFixed(2)}
                                    </p>
                                    <p>
                                      VAT: total - actual fee = ${totalFee.toFixed(2)} - ${(totalFee / 1.1).toFixed(2)}{" "}
                                      = ${(totalFee - totalFee / 1.1).toFixed(2)}
                                    </p>
                                  </Modals.Section>
                                </>
                              ),
                            });
                          }}
                          style={{ cursor: "pointer", color: "#047BFB" }}
                        >
                          <PricesToolTips messageId={3}>
                            {t("general.fee")}
                            <b> (?)</b>
                          </PricesToolTips>
                        </div>
                      ),
                      alignment: "start",
                    },
                    { title: "Net Sales", alignment: "end" },
                  ] as any
                }
                itemCount={(data && data.supplierDisbursementDetail.length) || 0}
                loading={loading}
                selectable={false}
              >
                {data && (
                  <IndexTable.Row id="-1" position={-1} tone="success">
                    <IndexTable.Cell>
                      <div style={{ width: 100 }}>Total:</div>
                    </IndexTable.Cell>
                    <IndexTable.Cell></IndexTable.Cell>
                    <IndexTable.Cell>
                      <Text as="p" variant="headingSm">
                        $
                        {Number(
                          (data.supplierDisbursementDetail as any[]).reduce((a, b) => (a = a + Number(b.price)), 0),
                        ).toFixed(2)}
                      </Text>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <div className="text-start">
                        <Text as="p" variant="headingSm" tone="critical">
                          -$
                          {Number(
                            (data.supplierDisbursementDetail as any[]).reduce(
                              (a, b) => (a = a + Number(b.deliveryFee) + Number(b.handlingFee) + Number(b.commission)),
                              0,
                            ),
                          ).toFixed(2)}
                        </Text>
                      </div>
                    </IndexTable.Cell>
                    <IndexTable.Cell>
                      <div style={{ textAlign: "end" }}>
                        <Text as="p" variant="headingSm" tone="success">
                          $
                          {Number(
                            (data.supplierDisbursementDetail as any[]).reduce(
                              (a, b) => (a = b.type === "FEE" ? a - Number(b.amount) : a + Number(b.amount)),
                              0,
                            ),
                          ).toFixed(2)}
                        </Text>
                      </div>
                    </IndexTable.Cell>
                  </IndexTable.Row>
                )}
                {data &&
                  data.supplierDisbursementDetail.map((item: any, index: number) => {
                    if (item.type === "FEE") {
                      const des = String(item.description).split("#");
                      return (
                        <IndexTable.Row key={index} id={index + ""} position={index} tone="success">
                          <IndexTable.Cell></IndexTable.Cell>
                          <IndexTable.Cell>
                            <div style={{ display: "flex", alignItems: "center" }}>
                              <Avatar
                                source={des.length > 1 ? "/fbl_fee.svg" : "/inventory_fee.svg"}
                                initials={item.description.charAt(0)}
                                size="md"
                              />
                              <div className="ml-2">
                                <small>{item.description}</small>
                              </div>
                            </div>
                          </IndexTable.Cell>
                          <IndexTable.Cell></IndexTable.Cell>
                          <IndexTable.Cell>
                            <small className="text-danger">${Number(item.amount).toFixed(2)}</small>
                          </IndexTable.Cell>
                          <IndexTable.Cell>
                            <div style={{ textAlign: "end" }} className="text-danger">
                              ${Number(item.amount).toFixed(2)}
                            </div>
                          </IndexTable.Cell>
                        </IndexTable.Row>
                      );
                    }

                    return (
                      <IndexTable.Row key={index} id={index + ""} position={index}>
                        <IndexTable.Cell>
                          <div style={{ width: 100 }}>
                            {/* <Link target="_blank" to={`/order/v2/detail/${item.orderId}`}>
                              <small>{item.orderId}</small>
                            </Link> */}
                            {/* <br /> */}
                            <Link target="_blank" to={`/order/v2/px/${item.orderUUID}`}>
                              <small>{item.orderUUID}</small>
                            </Link>
                          </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                              <Image source={item.item.thumbnail} alt="" size="medium" />
                            </div>
                            <div className="ml-2">
                              <small>{item.item.supplierCode}</small>
                              <br />
                              <small>L192: {item.item.code}</small>
                              <br />
                              <small className="text-muted">
                                {item.color} | {item.size}
                              </small>
                            </div>
                          </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell>${item.price.toFixed(2)}</IndexTable.Cell>
                        <IndexTable.Cell>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "start" }}>
                            <div
                              className="text-muted pl-2 pr-2 mr-1"
                              style={{
                                borderLeft: "0.0625rem solid rgba(221,224,228,1)",
                                borderRight: "0.0625rem solid rgba(221,224,228,1)",
                                borderTopWidth: 0,
                                borderBottomWidth: 0,
                              }}
                            >
                              <small>DF: ${item.deliveryFee.toFixed(2)}</small>
                              <br />
                              <small>HF: ${item.handlingFee.toFixed(2)}</small>
                              <br />
                              <small>CM: ${item.commission.toFixed(2)}</small>
                            </div>
                            <div>
                              <small>
                                ={" "}
                                <span className="text-danger">
                                  ${(item.deliveryFee + item.handlingFee + item.commission).toFixed(2)}
                                </span>
                              </small>
                            </div>
                          </div>
                        </IndexTable.Cell>
                        <IndexTable.Cell>
                          <div style={{ textAlign: "end" }}>${item.amount.toFixed(2)}</div>
                        </IndexTable.Cell>
                      </IndexTable.Row>
                    );
                  })}
              </IndexTable>
              <Divider borderColor="border" borderWidth="050" />
            </LegacyCard.Section>
            <LegacyCard.Section>
              <UploadInternalTransferProof />
            </LegacyCard.Section>
          </LegacyCard>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
